const INVITE_STATUSES = [
    'Empty',
    'Sent',
    'Expired',
    'Failed',
    'Completed'
];

export default INVITE_STATUSES;